import { render, staticRenderFns } from "./SpeechTestVue.vue?vue&type=template&id=d33b2a6a&scoped=true"
import script from "./SpeechTestVue.vue?vue&type=script&lang=js"
export * from "./SpeechTestVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b2a6a",
  null
  
)

export default component.exports